"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Text = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
/* istanbul ignore next */
var H1 = _styledComponents["default"].h1.withConfig({
  displayName: "H1",
  componentId: "sc-181lvw2-0"
})(["text-align:", ";font-family:Raleway;font-weight:", ";font-size:", ";color:", ";letter-spacing:0.27px;line-height:", ";-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;", ""], function (props) {
  return props.align;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.fontSize ? props.fontSize : '24px';
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.lineHeight ? props.lineHeight : '32px';
}, function (props) {
  return props.ellipsis;
});
/* istanbul ignore next */
var H2 = _styledComponents["default"].h2.withConfig({
  displayName: "H2",
  componentId: "sc-181lvw2-1"
})(["text-align:", ";font-family:Raleway;font-weight:", ";font-size:", ";color:", ";letter-spacing:0.27px;line-height:", ";-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;", ""], function (props) {
  return props.align;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.fontSize ? props.fontSize : '20px';
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.lineHeight ? props.lineHeight : '32px';
}, function (props) {
  return props.ellipsis;
});
/* istanbul ignore next */
var H3 = _styledComponents["default"].h3.withConfig({
  displayName: "H3",
  componentId: "sc-181lvw2-2"
})(["text-align:", ";font-family:Raleway;font-weight:", ";font-size:", ";color:", ";letter-spacing:0.27px;line-height:", ";@media (max-width:380px){font-size:16px;}@media (max-width:320px){font-size:15px;}-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;", ""], function (props) {
  return props.align;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.fontSize ? props.fontSize : '18px';
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.lineHeight ? props.lineHeight : '19px';
}, function (props) {
  return props.ellipsis;
});
/* istanbul ignore next */
var H4 = _styledComponents["default"].h4.withConfig({
  displayName: "H4",
  componentId: "sc-181lvw2-3"
})(["text-align:", ";font-family:Raleway;font-weight:", ";font-size:", ";color:", ";letter-spacing:0.27px;line-height:", ";@media (max-width:380px){font-size:", ";}-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;", ""], function (props) {
  return props.align;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.fontSize ? props.fontSize : '16px';
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.lineHeight ? props.lineHeight : '19px';
}, function (props) {
  return props.fontSize ? props.fontSize : '14px';
}, function (props) {
  return props.ellipsis;
});
/* istanbul ignore next */
var H5 = _styledComponents["default"].h5.withConfig({
  displayName: "H5",
  componentId: "sc-181lvw2-4"
})(["text-align:", ";font-family:", ";font-weight:", ";font-size:", ";color:", ";letter-spacing:0.27px;line-height:19px;@media (max-width:380px){font-size:", ";}-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;", ""], function (props) {
  return props.align;
}, function (props) {
  return props.fontFamily ? props.fontFamily : 'Raleway';
}, function (props) {
  return props.weight;
}, function (props) {
  return props.fontSize ? props.fontSize : '16px';
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.fontSize ? props.fontSize : '14px';
}, function (props) {
  return props.ellipsis;
});
/* istanbul ignore next */
var Paragraph = _styledComponents["default"].p.withConfig({
  displayName: "Paragraph",
  componentId: "sc-181lvw2-5"
})(["text-align:", ";font-family:Raleway;font-weight:", ";font-size:", ";@media (max-width:380px){font-size:", ";}color:", ";letter-spacing:0.27px;line-height:", ";-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;", ""], function (props) {
  return props.align;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.fontSize ? props.fontSize : '14px';
}, function (props) {
  return props.fontSize ? props.fontSize : '13px';
}, function (props) {
  return props.fontColor;
}, function (props) {
  return props.lineHeight ? props.lineHeight : '19px';
}, function (props) {
  return props.ellipsis;
});
var textTypes = {
  h1: H1,
  h2: H2,
  h3: H3,
  h4: H4,
  h5: H5,
  p: Paragraph
};
var weightGroup = {
  thin: 100,
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
  blackBold: 900
};
var Text = function Text(props) {
  var textSize = props.textSize || 'h3';
  var CustomText = textTypes[textSize];
  var align = props.align || 'left';
  var fontWeight = props.fontWeight || 400;
  var customFontWeight = weightGroup[fontWeight];
  var lineHeight = props.lineHeight;
  var ellipsis = '';
  if (props.ellipsis) {
    ellipsis = "\n      overflow: hidden;\n      text-overflow: ellipsis;\n    ";
  }
  return /*#__PURE__*/_react["default"].createElement(CustomText, {
    fontColor: props.fontColor,
    align: align,
    fontWeight: customFontWeight,
    lineHeight: lineHeight,
    fontSize: props.fontSize,
    ellipsis: ellipsis
  }, props.text, props.children);
};
exports.Text = Text;
var _default = Text;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(H1, "H1", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(H2, "H2", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(H3, "H3", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(H4, "H4", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(H5, "H5", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(Paragraph, "Paragraph", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(textTypes, "textTypes", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(weightGroup, "weightGroup", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(Text, "Text", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Text.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();